<template>
  <div>
    <div class="Figure1">
      <!-- <img src="../../assets/img/9dfe1efc95458419db191ab25366fd9.jpg" alt=""> -->
      <!-- height="32vw" -->
      <el-carousel :interval="5000" arrow="always" height="600px" v-if="this.qw == 1">
        <el-carousel-item v-for="(item, index) in arr" :key="index">
          <img :src="url+item.image" alt />
        </el-carousel-item>
      </el-carousel>

      <el-carousel :interval="5000" arrow="always" height="240px" v-if="this.qw == 2">
        <el-carousel-item v-for="(item, index) in arr" :key="index">
          <img :src="item.simgurl" alt />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "slideshow",
  data() {
    return {
      qq: "",
      qw: "",
      zqkuan: "",
      xzkuan: "",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      url:this.$axios.defaults.baseURL,
      arr: [],
      //  url:'/static/upfile/slide/',
      //  htt:'http://192.168.110.253/test1',
    };
  },
  watch: {
    windowHeight(val) {
      let that = this;
      // console.log("实时屏幕高度：",val, that.windowHeight );

      // console.log(val, "实时屏幕高度：");
      // this.qq= val
    },
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowWidth);
      // console.log(val, "实时屏幕宽度：");
      if (that.windowWidth > 1000) {
        this.qw = 1
      } else if (that.windowWidth < 1000) {
        this.qw = 2
      }
    },
  },
  created() {
    console.log(this.windowWidth, "生命周期");
    if (this.windowWidth > 1000) {
      this.qw = 1
    } else if (this.windowWidth < 1000) {
      this.qw = 2
    }
    console.log(this.zqkuan, "zq");
    console.log(this.xzkuan, "xz");


    this.banner();
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },

  methods: {
    banner: function () {
      this.$axios({
        method: "get",
        url: "/changhang/index/list?type=1&menu=1",
      })
        .then((res) => {
          this.arr = res.data.rows;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
  },
};
</script>

<style scoped>
.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  height: 50px;
  /* margin: 1; */
}

.Figure1 {
  /* margin-top: 20px; */
  width: 100%;
  height: 600px;
}

img {
  width: 100%;
  height: 100%;
}

.el-carousel__container {
  height: 600px !important;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .Figure1 .el-carousel__container {
    height: 240px !important;
  }

  .Figure1 {
    width: 100%;
    height: 100%;
  }

  img {
    height: 240px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/haed/slideshow.vue